import { render, staticRenderFns } from "./your-buy-sell-table.vue?vue&type=template&id=a5e07176&"
import script from "./your-buy-sell-table.vue?vue&type=script&lang=js&"
export * from "./your-buy-sell-table.vue?vue&type=script&lang=js&"
import style0 from "./your-buy-sell-table.vue?vue&type=style&index=0&id=a5e07176&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports